import { SalesforceConnectRequestSchema } from '@vy/api-definition';
import type { oz } from '@vy/utils';

export const SalesforceRegisterFormSchema = SalesforceConnectRequestSchema;

export type SalesforceRegisterFormValues = oz.infer<typeof SalesforceRegisterFormSchema>;
